'use strict';

import 'slick-carousel';
import '../../../../../node_modules/slick-carousel/slick/slick.css';
import '../../../../../node_modules/slick-carousel/slick/slick-theme.css';

;(function(){
      $(function(){
            const $slide = $('.other-cp-list');
            $slide.slick({
                  slidesToShow: 3,
                  responsive:[
                        {
                              breakpoint: 768,//ブレイクポイント
                              settings: {
                                    infinite:true,
                                    slidesToShow: 1,
                                    autoplay: true,
                                    autoplaySpeed: 3000,
                                    dots:true,
                                    arrows: false,
                                    centerMode: true,
                                    centerPadding: '30px',
                              }
                        },
                  ]
            });
      });
})();
